import { createPortal } from "react-dom";
import type { ReactNode, ReactPortal } from "react";

/**
 * SSR-safe portal helper: on the server there is no `document`, so render
 * nothing; on the client behave exactly like createPortal(children, document.body).
 */
export function safeCreatePortal(
  children: ReactNode,
  container?: Element | DocumentFragment,
): ReactPortal | null {
  if (typeof document === "undefined") return null;
  return createPortal(children, container ?? document.body);
}
